const AGENT_LABELS: Record<string, string> = {
  planner_agent: 'Planning the response',
  research_agent: 'Researching the web',
  market_research_agent: 'Researching your market',
  text2sql_agent: 'Querying your business data',
  goal_management_agent: 'Reading your goals',
  user_business_management_agent: 'Reviewing your business',
  data_discovery_agent: 'Analyzing your data',
  platform_data_agent: 'Pulling platform data',
  meeting_context_agent: 'Reviewing your meetings',
  query_user_agent: 'Looking up user info',
  update_user_agent: 'Updating your profile',
  system_report_agent: 'Building a report',
  progress_analytics_agent: 'Analyzing your progress',
  handoff_agent: 'Handing off to a specialist',
  synthesis: 'Composing the answer',
}

const TOOL_LABELS: Record<string, string> = {
  'vector-search': 'Searching knowledge base',
  vector_search: 'Searching knowledge base',
  'tavily-search': 'Searching the web',
  tavily_search: 'Searching the web',
  'web-search': 'Searching the web',
  'query-platform-data': 'Querying platform data',
  query_platform_data: 'Querying platform data',
  'extract-file-data': 'Reading attached files',
  extract_file_data: 'Reading attached files',
  'export-file': 'Generating a file',
  export_file: 'Generating a file',
  'get-insights': 'Reading insights',
  get_insights: 'Reading insights',
  'ibis-search': 'Searching market data',
  ibis_search: 'Searching market data',
  text2sql: 'Running a database query',
  bigquery: 'Running a database query',
}

function humanize(token: string): string {
  return token
    .replace(/[_-]+/g, ' ')
    .replace(/\bagent\b/i, '')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase())
}

export function friendlyAgentLabel(agent: string | undefined, fallback?: string): string {
  if (!agent) return fallback || 'Working'
  return AGENT_LABELS[agent] || fallback || humanize(agent)
}

export function friendlyToolLabel(tool: string | undefined, fallback?: string): string {
  if (!tool) return fallback || 'Running tool'
  return TOOL_LABELS[tool] || fallback || humanize(tool)
}
